module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAU0lEQVQ4y2NgGBTgnKDaf2z4z0UxvHg4GrCKTx6MyTJgIo/0fwMWzv/GQAxik+UCJWY2MIbxGeZ54sfIBhwXUP2/hk8BjI8IqJBuADY8hAwY2gAAGkBWxd81JqMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GW.png
// module id = 1157
// module chunks = 0